export const CONSTANTS = {
	localStorage: {
		ETPay: 'RVRQYXk=',
	},
	alertMessages: {
		noVoucherAvailable: 'No hay órdenes de pago disponibles para este link.',
	},
	cookies: {
		authorization: 'QXV0aG9yaXphdGlvbg==',
		accessToken: 'YWNjZXNzLXRva2Vu',
		refreshToken: 'cmVmcmVzaC10b2tlbg==',
		user: 'dXNlcg==',
	},
	mails: {
		mailTo: 'soporte@etpay.com',
	},
	services: {
		home: {
			getGraphData: 'getHomeGraphData',
			getStatistics: 'getHomeStatistics',
		},
		merchant: {
			getMerchantsList: 'getMerchantsList',
		},
		allPayments: {
			getGraphData: 'getAllPaymentsGraphData',
			getTableInfo: 'getAllPaymentsTableInfo',
		},
		quickTransfer: {
			getGraphData: 'getQuickTransferGraphData',
			getTableInfo: 'getQuickTransferTableInfo',
		},
		paymentLinks: {
			getGraphData: 'getPaymentLinksGraphData',
			getTableInfo: 'getPaymentLinksTableInfo',
		},
		paymentLinksCustom: {
			getStatistics: 'getPaymentLinksCustomStatistics',
			getStatisticsSale: 'getPaymentLinksCustomStatisticsSale',
			getGraphData: 'getPaymentLinksCustomGraphData',
			getAllPayments: 'getPaymentLinksCustomAllPayments',
			getLinkPayments: 'getPaymentLinksCustomLinkPayments',
			getLastPayments: 'getPaymentLinksCustomLastPayments',
			getAllLinks: 'getPaymentLinksCustomAllLinks',
			getTableSales: 'getPaymentLinksCustomTableSales',
		},
		paymentLinksMultiuse: {
			getTableInfo: 'getPaymentLinksMultiuseTableInfo',
		},
		businessTransfer: {
			getGraphData: 'getBusinessTransferGraphData',
			getTableInfo: 'getBusinessTransferTableInfo',
		},
		nonBankCards: {
			getGraphData: 'getNonBankCardsGraphData',
			getTableInfo: 'getNonBankCardsTableInfo',
		},
		conciliation: {
			getTableInfo: 'getConciliationTableInfo',
		},
		analytics: {
			getGraphData: 'getAnalyticsGraphData',
			getGraphInfo: 'getAnalyticsGraphInfo',
		},
		eatm: {
			getGraphData: 'getEAtmGraphData',
			getTableInfo: 'getEAtmTableInfo',
			getCashAllowed: 'getEAtmCashAllowed',
		},
		directDebitMx: {
			getTableInfo: 'getDirectMxDebitTableInfo',
		},
		directDebit: {
			getGraphData: 'getDirectDebitGraphData',
			getTableInfo: 'getDirectDebitTableInfo',
			rendition: {
				getTableInfo: 'getDirectDebitRenditionTableInfo',
			},
		},
		refund: {
			payments: {
				getTableInfo: 'getRefundPaymentsTableInfo',
			},
			returns: {
				getTableInfo: 'getRefundReturnsTableInfo',
			},
			getCashAllowed: 'getEAtmCashAllowed',
		},
		outbound: {
			getTableInfo: 'getOutboundTableInfo',
			getCashAllowed: 'getEAtmCashAllowed',
		},
		payoutsChile: {
			getTableInfo: 'getPayoutsChileTableInfo',
			getBalance: 'getBalance',
			getStats: 'getStats',
			getTableBeneficiary: 'getTableBeneficiary',
		},
		profile: {
			getInformation: 'getProfileInformation',
		},
		development: {
			commerceInformation: {
				getInformation: 'getMerchantsInformation',
			},
		},
		config: {
			accountInformation: {
				getInformation: 'getAccountInformation',
			},
			contacts: {
				getInformation: 'getContactInformation',
			},
			personalization: {
				getInformation: 'getPersonalizationInformation',
			},
			users: {
				getUserList: 'getUserList',
			},
			subscription: {
				getPlans: 'getSubscriptionPlans',
				getMyCurrentPlan: 'getMyCurrentPlan',
			},
		},
	},
};
